import React from 'react'

const accounting = () => {
  return (
    <>
    <div className="audit-page">
        <section className="audit-cover accounting">
           <div className="container">
              <div className="audit-cover-para">
                <h1 style={{color: "#f1f1f1", fontSize: "42px"}}>ACCOUNTING & OTHER SERVICES</h1>
              </div>
           </div>
        </section>
        <section className="audit-page-content container">
           <p>We provide accounting and other business related services.</p>
            <p><strong>Our Services include:</strong></p>
           <p>&#x2022; Financial Accounting including Transactions Entry, BRS, General Ledger Maintenance</p>
           <p>&#x2022; Budgeting & MIS Reports</p>
           <p>&#x2022; Financial Reporting includes Preparation of P&L, Balance Sheet, Cash flow Statements</p>
           <p>&#x2022; Financial Analysis includes Ageing reports and analysis, etc.</p>
           <p>&#x2022; Asset Accounting Management includes Fixed Assets Register, Depreciation & Amortization Schedule.</p>
           <p>&#x2022; Tax Accounting </p>
           <p>&#x2022; Payroll accounting</p>
        </section>
    </div> 
  </>
  )
}

export default accounting
